(function (root, factory) {
  'use strict';

  if (typeof module === 'object' && module.exports) {
    module.exports = factory;
    return;
  }

  if (!root || !root.document) return;

  root.VmaxWishlistSearchResults = root.VmaxWishlistSearchResults
    || factory(root, root.document);
  root.VmaxWishlistSearchResults.initialize();
})(typeof window !== 'undefined' ? window : this, function (win, doc) {
  'use strict';

  var ROOT_SELECTOR = '[data-vmax-binder-results]';
  var ACTIONS_SELECTOR = '.products-display .thumbnail-buttons';
  var PRODUCT_CARD_SELECTOR = '.grid-view-item';
  var FOCUS_STYLE_ID = 'vmax-wishlist-search-focus-styles';
  var OUTLINE_HEART_PATH = 'M511.825 170.191c-.14-1.786-.298-3.155-.44-4.095C504.22 84.955 444.691 20.73 367.434 20.73c-44.758 0-85.66 21.18-112.442 55.516C228.835 41.679 189.491 20.73 144.97 20.73 67.976 20.73 8.584 84.52.937 166.557c-.147.956-.295 2.12-.43 3.489C-.8 183.3.287 200.862 5.338 222.26c10.732 45.463 35.828 86.871 71.224 118.958l164.828 144.92c8.028 7.059 20.042 7.085 28.101.062l166.037-144.683c39.134-40.728 62.393-77.366 71.616-119.584 4.627-21.202 5.704-38.649 4.681-51.742zM465.46 212.833c-7.254 33.204-26.552 63.603-59.352 97.843L255.545 441.771l-150.569-132.38c-28.881-26.184-49.406-60.051-58.113-96.933-3.953-16.747-4.747-29.585-3.895-38.225.075-.764.393-3.072.393-3.072C48.849 109.384 91.478 63.397 144.97 63.397c39.823 0 73.704 24.287 90.17 63.294 7.338 17.382 31.97 17.382 39.308 0 16.136-38.225 52.419-63.294 92.986-63.294 53.494 0 96.121 45.99 101.609 107.786.147 1.242.187 1.586.245 2.333.705 9.025-.114 22.295-3.828 39.317z';
  var FILLED_HEART_PATH = 'M511.489 167.372C503.916 82.38 443.329 20.705 367.382 20.705c-44.395 0-85.483 20.928-112.427 55.488-26.475-34.923-66.155-55.488-110.037-55.488C69.227 20.705 8.747 82.017.875 166.561c-.811 5.483-2.795 25.045 4.395 55.68 10.71 45.291 35.35 86.422 71.489 119.169l164.608 144.704c4.011 3.541 9.067 5.312 14.08 5.312 4.992 0 10.005-1.749 14.016-5.248L436.865 340.13c24.704-25.771 58.859-66.048 70.251-118.251 7.275-33.365 4.544-53.611 4.373-54.507z';
  var initialized = false;
  var started = false;
  var observer = null;
  var frame = null;

  function ensureFocusStyles() {
    if (!doc || typeof doc.createElement !== 'function') return;
    if (typeof doc.getElementById === 'function' && doc.getElementById(FOCUS_STYLE_ID)) return;

    var style = doc.createElement('style');
    style.setAttribute('id', FOCUS_STYLE_ID);
    style.textContent = ROOT_SELECTOR
      + ' .products-display .grid-view-item:focus-within .thumbnail-buttons .add-to-wishlist,'
      + ROOT_SELECTOR
      + ' .products-display .grid-view-item:focus-within .thumbnail-buttons .product-block-hover'
      + '{opacity:1;transform:translateX(0);}'
      + ROOT_SELECTOR
      + ' .add-in-wishlist-js:focus-visible'
      + '{outline:2px solid var(--product-icon-hover-color,#000);outline-offset:2px;}';
    (doc.head || doc.documentElement).appendChild(style);
  }

  function normalizeHandle(value) {
    if (typeof value !== 'string') return null;

    var handle = value.trim().toLowerCase();
    if (!handle || handle === 'undefined' || handle === 'null') return null;
    if (handle.length > 255 || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)) return null;

    return handle;
  }

  function extractHandle(href) {
    if (typeof href !== 'string' || !href.trim() || !win.location || !win.URL) return null;

    try {
      var productUrl = new win.URL(href, win.location.href);
      if (productUrl.origin !== win.location.origin || productUrl.pathname.indexOf('//') !== -1) {
        return null;
      }

      var segments = productUrl.pathname.split('/').filter(function (segment) {
        return segment !== '';
      });
      var productIndex = -1;

      for (var index = 0; index < segments.length; index += 1) {
        if (segments[index] === 'products') productIndex = index;
      }

      if (productIndex < 0 || productIndex !== segments.length - 2) return null;
      return normalizeHandle(decodeURIComponent(segments[productIndex + 1]));
    } catch (error) {
      return null;
    }
  }

  function hasClass(element, className) {
    return !!(element && element.classList && element.classList.contains(className));
  }

  function findProductCard(actions) {
    if (!actions) return null;
    if (typeof actions.closest === 'function') return actions.closest(PRODUCT_CARD_SELECTOR);

    var element = actions.parentNode;
    while (element && element !== doc) {
      if (hasClass(element, 'grid-view-item')) return element;
      element = element.parentNode;
    }

    return null;
  }

  function findProductHandle(card) {
    if (!card || typeof card.querySelectorAll !== 'function') return null;

    var links = card.querySelectorAll('a[href]');
    for (var index = 0; index < links.length; index += 1) {
      var handle = extractHandle(links[index].getAttribute('href'));
      if (handle) return handle;
    }

    return null;
  }

  function findDirectCart(actions) {
    if (!actions || !actions.children) return null;

    for (var index = 0; index < actions.children.length; index += 1) {
      if (hasClass(actions.children[index], 'product-block-hover')) {
        return actions.children[index];
      }
    }

    return null;
  }

  function createHeartIcon(filled) {
    var svg = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');

    svg.setAttribute('class', 'icon vmax-wishlist-heart-svg');
    svg.setAttribute('viewBox', '0 0 512 512');
    svg.setAttribute('width', '15');
    svg.setAttribute('height', '15');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    path.setAttribute('d', filled ? FILLED_HEART_PATH : OUTLINE_HEART_PATH);
    svg.appendChild(path);

    return svg;
  }

  function appendTooltip(control, label) {
    var tooltip = doc.createElement('span');
    tooltip.className = 'tooltip-label';
    tooltip.textContent = label;
    control.appendChild(tooltip);
  }

  function createWishlistControl(handle, labels) {
    var wishlist = doc.createElement('div');
    var show = doc.createElement('div');
    var defaultState = doc.createElement('div');
    var addButton = doc.createElement('button');
    var loadingState = doc.createElement('div');
    var loadingIndicator = doc.createElement('span');
    var addedState = doc.createElement('div');
    var addedLink = doc.createElement('a');

    wishlist.className = 'add-to-wishlist';
    wishlist.setAttribute('data-vmax-wishlist-search-control', handle);
    show.className = 'show';

    defaultState.className = 'default-wishbutton-' + handle + ' loading';
    addButton.className = 'add-in-wishlist-js btn';
    addButton.setAttribute('type', 'button');
    addButton.setAttribute('data-href', handle);
    addButton.setAttribute('aria-label', labels.add);
    addButton.setAttribute('title', labels.add);
    addButton.appendChild(createHeartIcon(false));
    appendTooltip(addButton, labels.add);
    defaultState.appendChild(addButton);

    loadingState.className = 'loadding-wishbutton-' + handle + ' loading btn loader-btn';
    loadingState.style.display = 'none';
    loadingState.style.pointerEvents = 'none';
    loadingIndicator.setAttribute('aria-hidden', 'true');
    loadingIndicator.textContent = '\u2026';
    loadingState.appendChild(loadingIndicator);

    addedState.className = 'added-wishbutton-' + handle + ' loading';
    addedState.style.display = 'none';
    addedLink.className = 'added-wishlist btn add_to_wishlist';
    addedLink.setAttribute('href', labels.url);
    addedLink.setAttribute('aria-label', labels.view);
    addedLink.setAttribute('title', labels.view);
    addedLink.appendChild(createHeartIcon(true));
    appendTooltip(addedLink, labels.view);
    addedState.appendChild(addedLink);

    show.appendChild(defaultState);
    show.appendChild(loadingState);
    show.appendChild(addedState);
    wishlist.appendChild(show);

    return wishlist;
  }

  function getLabels(rootElement) {
    var strings = (win.theme && win.theme.strings && win.theme.strings.wishlist) || {};
    return {
      add: rootElement.getAttribute('data-vmax-wishlist-add-label')
        || strings.add || '',
      view: rootElement.getAttribute('data-vmax-wishlist-view-label')
        || strings.view || '',
      url: rootElement.getAttribute('data-vmax-wishlist-url') || (win.routes && win.routes.wishlistUrl) || ''
    };
  }

  function injectRoot(rootElement) {
    if (!rootElement || typeof rootElement.querySelectorAll !== 'function') return 0;

    var labels = getLabels(rootElement);
    var actionsList = rootElement.querySelectorAll(ACTIONS_SELECTOR);
    var inserted = 0;

    for (var index = 0; index < actionsList.length; index += 1) {
      var actions = actionsList[index];
      if (actions.querySelector('.add-to-wishlist')) continue;

      var cart = findDirectCart(actions);
      if (!cart) continue;

      var handle = findProductHandle(findProductCard(actions));
      if (!handle) continue;

      actions.insertBefore(createWishlistControl(handle, labels), cart);
      inserted += 1;
    }

    return inserted;
  }

  function syncWishlistButtons() {
    if (win.VmaxWishlist && typeof win.VmaxWishlist.syncButtons === 'function') {
      win.VmaxWishlist.syncButtons();
    }
  }

  function hydrate() {
    if (!doc || typeof doc.querySelectorAll !== 'function') return 0;

    var roots = doc.querySelectorAll(ROOT_SELECTOR);
    var inserted = 0;
    for (var index = 0; index < roots.length; index += 1) {
      inserted += injectRoot(roots[index]);
    }

    if (inserted > 0) syncWishlistButtons();
    return inserted;
  }

  function queueHydration() {
    if (frame !== null) return;

    var requestFrame = typeof win.requestAnimationFrame === 'function'
      ? win.requestAnimationFrame.bind(win)
      : function (callback) { return win.setTimeout(callback, 0); };

    frame = requestFrame(function () {
      frame = null;
      hydrate();
    });
  }

  function isBinderRoot(node) {
    return !!(node && typeof node.matches === 'function' && node.matches(ROOT_SELECTOR));
  }

  function isInsideBinderRoot(node) {
    if (!node) return false;
    if (isBinderRoot(node)) return true;

    var element = node;
    if (typeof element.closest !== 'function') element = node.parentElement || node.parentNode;
    return !!(element && typeof element.closest === 'function' && element.closest(ROOT_SELECTOR));
  }

  function containsBinderRoot(node) {
    if (isBinderRoot(node)) return true;
    return !!(node && typeof node.querySelector === 'function' && node.querySelector(ROOT_SELECTOR));
  }

  function mutationTouchesBinderResults(mutations) {
    if (!mutations || typeof mutations.length !== 'number') return false;

    for (var index = 0; index < mutations.length; index += 1) {
      var mutation = mutations[index];
      if (isInsideBinderRoot(mutation.target)) return true;

      var addedNodes = mutation.addedNodes || [];
      for (var addedIndex = 0; addedIndex < addedNodes.length; addedIndex += 1) {
        if (containsBinderRoot(addedNodes[addedIndex])) return true;
      }

      var removedNodes = mutation.removedNodes || [];
      for (var removedIndex = 0; removedIndex < removedNodes.length; removedIndex += 1) {
        if (containsBinderRoot(removedNodes[removedIndex])) return true;
      }
    }

    return false;
  }

  function handleMutations(mutations) {
    if (mutationTouchesBinderResults(mutations)) queueHydration();
  }

  function start() {
    if (started) return;
    started = true;
    ensureFocusStyles();
    hydrate();

    if (typeof win.MutationObserver === 'function') {
      observer = new win.MutationObserver(handleMutations);
      observer.observe(doc.body || doc.documentElement, { childList: true, subtree: true });
    }
  }

  function initialize() {
    if (initialized) return api;
    initialized = true;

    if (doc.readyState === 'loading' && typeof doc.addEventListener === 'function') {
      doc.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    return api;
  }

  var api = {
    version: '1.0.0',
    initialize: initialize,
    hydrate: hydrate
  };

  return api;
});
